export enum EAlignTypes {
  START = 'start',
  CENTER = 'center',
  END = 'end'
}

export enum EJustifyTypes {
  START = 'start',
  CENTER = 'center',
  END = 'end',
  BETWEEN = 'space-between',
  AROUND = 'space-around',
  EVENLY = 'space-evenly',
  FLEX_START = 'flex-start',
  FLEX_END = 'flex-end'
}
